import React from "react";
import { ReactComponent as DownloadIcon } from '../../components/Common/BootstrapIcons/download.svg';
import { ReactComponent as EditIcon } from '../../components/Common/BootstrapIcons/edit.svg';
import { ReactComponent as HistoryIcon } from '../../components/Common/BootstrapIcons/history.svg';
import ColumnDefinition from "../../infrastructure/types/DataGrid/ColumnDefinition";
import BusinessAnalysisDocument from "../../types/businessAnalysis/BusinessAnalysisDocument";
import CustomIcon from "../Common/BootstrapIcons/Custom/CustomIcon";
import iconTooltip from "../Common/BootstrapIcons/Tooltip/IconTooltip";
import EditableText from "../Common/EditableText/EditableText";
import Spinner from "../Common/Spinner/Spinner";

const uniqueName = 'business-analysis-home-grid';

const getColumns = (
    onEditClick: (id: number) => void,
    onDownloadClick: (id: number) => void,
    onChangeLogClick: (id: number) => void,
    onDocumentRenamed: (document: BusinessAnalysisDocument, newName: string) => void,
    showSpinner: boolean,
): ColumnDefinition<BusinessAnalysisDocument>[] => {

    return [
        {
            header: 'Id',
            sortKey: 'Id',
            getContent: x => x.id.toString(),
            width: '100px'
        },
        {
            header: 'Name',
            sortKey: 'Name',
            getContent: x => <EditableText onMouseLeave={(value: string) => onDocumentRenamed(x, value)}
                value={x.name}
                multiline={false} disabled={false} />,
            className: 'break-all',
            width: '300px'
        },
        {
            header: 'Actions',
            getContent: x =>
                <div className='display-flex align-items-center'>
                    <button className="custom-icon-button" onClick={() => onEditClick(x.id)}>
                        <CustomIcon icon={EditIcon} title={iconTooltip.edit} />
                    </button>
                    <button className="custom-icon-button" onClick={() => onChangeLogClick(x.id)}>
                        <CustomIcon icon={HistoryIcon} title={iconTooltip.changeLog} />
                    </button>
                    <button className="custom-icon-button button-spinner-font-size" onClick={() => onDownloadClick(x.id)}>
                        {
                           showSpinner ? <Spinner /> :
                                <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                        }
                    </button>
                </div>,
            className: 'display-flex',
            width: '300px'
        }
    ];
};

export { getColumns, uniqueName };